import { get } from '@hummingbirdtechgroup/wings-request';

const getUploadToken = apiUrl => {
  return get(apiUrl, '/v1/uav-uploads/auth-token');
};

export default getUploadToken;
